import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgAddPerson = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 14,
	viewBox: "0 0 20 14",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#4384F5",
			fillRule: "nonzero",
			d: "M12.5 7a3.332 3.332 0 1 0 0-6.667A3.332 3.332 0 1 0 12.5 7zM5 5.333v-2.5H3.333v2.5h-2.5V7h2.5v2.5H5V7h2.5V5.333H5zm7.5 3.334c-2.225 0-6.667 1.116-6.667 3.333v1.667h13.334V12c0-2.217-4.442-3.333-6.667-3.333z"
		})
	})
});
export default SvgAddPerson;
